import { Controller } from "@hotwired/stimulus"
import { autoUpdate, computePosition, flip, offset, shift } from "@floating-ui/dom"

let popoverId = 0

export default class extends Controller {
  static targets = ["content"]
  static values = { placement: { type: String, default: "top" } }

  connect() {
    this.element.dataset.popoverReady = "true"
  }

  disconnect() {
    this.hide()
    delete this.element.dataset.popoverReady
  }

  show() {
    if (this.popover || !this.hasContentTarget) return

    const popover = document.createElement("div")
    popover.id = `website-popover-${++popoverId}`
    popover.className = "popover"
    popover.setAttribute("role", "tooltip")
    popover.setAttribute("data-turbo-temporary", "")

    const body = document.createElement("div")
    body.className = "popover-body"
    body.append(this.contentTarget.content.cloneNode(true))
    popover.append(body)
    document.body.append(popover)

    this.popover = popover
    this.element.setAttribute("aria-describedby", popover.id)
    this.stopPositioning = autoUpdate(this.element, popover, () => this.position(popover))
  }

  hide() {
    this.stopPositioning?.()
    this.stopPositioning = null
    this.element.removeAttribute("aria-describedby")
    this.popover?.remove()
    this.popover = null
  }

  async position(popover) {
    const { x, y } = await computePosition(this.element, popover, {
      placement: this.placementValue,
      middleware: [offset(10), flip(), shift({ padding: 8 })]
    })
    if (this.popover !== popover) return

    Object.assign(popover.style, { left: `${x}px`, top: `${y}px` })
  }
}
